import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Form, Popover } from 'antd';
import Box from 'components/Box';
import { customerEditorRef } from 'features/appointment/pages/AppointmentsPage/components/Calendar/widgets/CustomerEditor';
import appointmentActions from 'features/appointment/services/actions';
import { APPOINTMENT_SOURCE_TYPE } from 'features/appointment/services/constants';
import { IAppointmentItemData } from 'features/appointment/services/types/appointment';
import { IAccountPackage } from 'features/customer/services/types/api';
import { CustomerInfoPopover, CustomerInfoPopoverUI, IconInfo, useCustomerInfoPopover } from 'features/user/widgets/WaitingList/WalkIn/components/CustomerName';
import { useState } from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { formatPhone, maskPhone } from 'utils/formatPhone';
import RequestAdminPWCallback, { useRequestAdminPWCallbackRef } from 'widgets/RequestAdminLocalPW/Callback';
import CustomerPopoverCheckPinCode from '../../../CustomerPopoverCheckPinCode';
import Text from 'components/Text';

type Props = {
  value?: {
    id: string; name: string, phone: string, point: string;
  },
  nameValue?: any;
  extraData?: IAppointmentItemData;
  v2?: boolean;
};
const CustomerInfo = ({ v2, value, nameValue: name, extraData }: Props) => {
  if (v2) {
    const getIcons = () => {
      switch (extraData?.sourceType) {
        case APPOINTMENT_SOURCE_TYPE.POS:
          return <IconCalling />;
        case APPOINTMENT_SOURCE_TYPE.APP:
          return <IconByApp />;
        default:
          return <IconOnline />;
      }
    };
    return (
      <CustomerBoxView display='flex' alignItems='center' px='3'>
        <CustomerPopoverCheckPinCode
          customerName={`${value?.name || ''} - ${maskPhone(value?.phone || '')}`}
          customerId={value?.id || ''}
          content={
            <CustomerText>
              {!!value?.id && <IconInfo />}
              <Text variant='H7' color='text_3' className='text-overflow'>
                {value?.name ? `${value?.name || ''} - ${maskPhone(value?.phone || '')}` : 'Unknown Customer'}
              </Text>
            </CustomerText>
          }
        />

        <AppointmentType>
          {/* {extraData.requestStaff && <IconRequestStaff />} */}
          {getIcons()}
        </AppointmentType>
      </CustomerBoxView>
    );
  }
  return (
    <Container className='CustomerInfo'>
      <div className="content-container">
        <div className="customer-name-phone-container">
          <Form.Item name={'visibleCusPhone'} noStyle>
            <CustomerPhone customer={value} extraData={extraData} />
          </Form.Item>
        </div>
        <div className="customer-point-container">
          <div className="customer-point-container-item border-r">
            <span className='label'>Point:</span>
            <span>{value?.point || '0 point = $0.00'}</span>
          </div>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const date = getFieldValue(name !== undefined ? ['appointments', name, 'aptDate'] : 'aptDate');
              return (
                <div className="customer-point-container-item">
                  <span className='label'>Appointment time:</span>
                  <span>{date?.format('MM-DD-YYYY hh:mm A')}</span>
                </div>
              );
            }}
          </Form.Item>
        </div>
      </div>
    </Container>
  );
};

export default CustomerInfo;

const CustomerBoxView = styled(Box)`
border-bottom: 1px solid #86909C;
background: #EEF4FF;
padding: 16px;
`;

type CustomerPhoneProps = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  customer?: Props['value'];
  extraData?: IAppointmentItemData;
};
const CustomerPhone = ({ customer: value, value: visible, onChange: setVisible = () => undefined, extraData }: CustomerPhoneProps) => {
  const pinCodeRef = useRequestAdminPWCallbackRef();
  const { customerInfo, customerDetailLoading, viewCustomer, open, setOpen, handleCheckPassBeforeView, dataPin, callback } = useCustomerInfoPopover(extraData?.customerId || '');
  const onToggle = () => {
    const nextValue = !visible;
    if (!nextValue) return setVisible(false);
    return pinCodeRef.current?.open(() => setVisible(true));
  };

  const onToggleCustomerBox = () => {
    return pinCodeRef.current?.open((pin, data) => {
      callback(pin, data);
    }, true);
  };

  // const customerInfo: CustomerInfoPopover = {
  //   customerId: extraData?.customerId || '',
  //   customerName: extraData?.customerName || '',
  //   customerPhone: extraData?.customerPhone || '',
  //   customerNote: extraData?.customerNote || '',
  //   customerHobbies: extraData?.customerHobbies || '',
  //   customerColor: extraData?.customerColor || '',
  //   customerHealth: extraData?.customerHealth || '',
  //   lastTimeVisited: extraData?.lastTimeVisited || '',
  //   numberVisited: extraData?.numberVisited || 0,
  //   accountPackage: extraData?.accountPackage || IAccountPackage.NEW,
  // };
  return (
    <>
      {/* <span>{value?.name || 'Unknown Customer'} - {value?.phone ? (visible ? formatPhone(value.phone) : maskPhone(value?.phone)) : formatPhone('0000000000')}</span> */}
      <CustomerBox
        id={extraData?.customerId || ''}
        visible={visible}
        extraData={extraData}
        onToggleCustomerBox={onToggleCustomerBox}
        customerInfo={customerInfo}
        customerDetailLoading={customerDetailLoading}
        open={open}
        setOpen={setOpen}
        handleCheckPassBeforeView={handleCheckPassBeforeView}
        dataPin={dataPin}
      />
      {value?.phone && <button style={{ width: 40, display: 'flex', alignItems: 'center', alignSelf: 'center', justifyContent: 'center' }} type='button' onClick={onToggle}>
        {!visible ? <EyeInvisibleOutlined style={{ fontSize: 30 }} /> : <EyeOutlined style={{ fontSize: 30 }} />}
      </button>}
      <Form.Item noStyle name={name !== undefined ? [name, 'sourceType'] : 'sourceType'}>
        <SourceType />
      </Form.Item>
      <RequestAdminPWCallback v2 ref={pinCodeRef} />
    </>
  );
};
type CustomerBoxProps = {
  id: string;
  extraData?: IAppointmentItemData;
  visible?: boolean;
  onToggleCustomerBox?: () => void;
  customerInfo?: CustomerInfoPopover;
  customerDetailLoading?: boolean;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  handleCheckPassBeforeView?: (open: boolean) => void;
  dataPin?: IStaffItemData;
}
const CustomerBox = ({ id, extraData, visible,
  onToggleCustomerBox,
  customerInfo,
  customerDetailLoading,
  open,
  setOpen,
  handleCheckPassBeforeView,
  dataPin,
}: CustomerBoxProps) => {
  const dispatch = useAppDispatch();
  // const { customerInfo, customerDetailLoading, viewCustomer, open, setOpen, dataPin } = useCustomerInfoPopover(id);
  const onOpenChange = (val: boolean) => handleCheckPassBeforeView?.(val);

  const onEdit = () => {
    customerEditorRef.current?.openWithId(customerInfo?.customerId || '', {
      addon: customerInfo, onSuccess: (data) => {
        if (data) {
          dispatch(appointmentActions.syncCustomerInfo(data));
        }
      }
    });
    setOpen?.(false);
  };

  return (
    <WrapperInfoBox >
      <Popover
        placement='rightTop'
        title={null}
        content={
          <CustomerInfoPopoverUI loading={customerDetailLoading} customerInfo={customerInfo} onOpenChange={onOpenChange} onEdit={onEdit} dataPin={dataPin} />
        }
        open={open}
        trigger={'click'}
        onOpenChange={onOpenChange}
        overlayInnerStyle={{ padding: 16, borderRadius: 8, background: '#E4F4F6' }}
      >
        <button style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', gap: '2px' }} type='button' onClick={onToggleCustomerBox}>
          {!!id && <IconInfo />}
          <span className='text-overflow'>{extraData?.customerName || 'Unknown'} - {extraData?.customerPhone ? (visible ? formatPhone(extraData.customerPhone) : maskPhone(extraData?.customerPhone)) : formatPhone('0000000000')}</span>
        </button>
      </Popover>
    </WrapperInfoBox>
  );
};
const CustomerText = styled.div`
display: flex;
align-items: center;
gap: 8px;

.text-overflow {
  color: #1D2129;
  font-family: Poppins;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
  
`;
const AppointmentType = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  zoom: 1.5;
`;

const WrapperInfoBox = styled.div`
  flex: 1;
  position: relative;
  align-self: stretch;
`;
const Container = styled.div`
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #86909C;
  background: #FFF;
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
  }

  .customer-name-phone-container {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    span {
      color: #1D2129;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .source-type-container {
      display: flex;
      align-items: center;
      gap: 4px;
      background: #FF7D00;
      border-radius: 4px;
      display: flex;
      padding: 2px 8px;
      span {
        color: #FFF;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      &.POS {
        background: #27616C;
      }
      &.APP {
        background: #D2464F;
      }
    }
  }

  .customer-point-container {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
    .customer-point-container-item {
      display: flex;
      padding-right: 24px;
      align-items: center;
      gap: 8px;
      &.border-r {
        border-right: 1px solid #CCD4DC;
      }

      span {
        color: #1D2129;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        &.label {
          color: #64748B
        }
      }
    }
  }
`;
export const SourceType = ({ value, onlyIcon }: { value?: APPOINTMENT_SOURCE_TYPE, onlyIcon?: boolean }) => {
  if (onlyIcon) {
    switch (value) {
      case APPOINTMENT_SOURCE_TYPE.POS:
        return <div className="source-type-container POS"><IconCalling /></div>;
      case APPOINTMENT_SOURCE_TYPE.APP:
        return <div className="source-type-container APP"><IconByApp /></div>;
      default:
        return <div className="source-type-container"><IconOnline /></div>;
    }
  }
  switch (value) {
    case APPOINTMENT_SOURCE_TYPE.POS:
      return <div className="source-type-container POS"><IconCalling /> <span>Call-in</span></div>;
    case APPOINTMENT_SOURCE_TYPE.APP:
      return <div className="source-type-container APP"><IconByApp /> <span>App</span></div>;
    default:
      return <div className="source-type-container"><IconOnline /> <span>Website</span></div>;
  }
};

const IconCalling = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="5" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 24 24)" fill="#27616C" />
    <path d="M20.6777 10.6875C20.8949 10.5318 21.0219 10.259 20.9969 9.99213C20.9045 9.16758 20.684 8.35739 20.3428 7.60094C19.5458 5.8256 18.0594 4.37123 16.2657 3.61552C15.5725 3.31257 14.8319 3.13441 14.0839 3.03208L13.8992 3.03208C13.5749 3.06742 13.2837 3.31736 13.2182 3.64018C13.142 3.94681 13.28 4.28804 13.5428 4.46105C13.7556 4.61307 14.0287 4.60461 14.2757 4.65062C15.4713 4.8608 16.6051 5.42253 17.4878 6.25664C18.5531 7.24536 19.2506 8.61985 19.4218 10.0632C19.4457 10.3311 19.5804 10.5977 19.8215 10.7309C20.0818 10.8881 20.4355 10.8715 20.6777 10.6875Z" fill="white" />
    <path d="M19.875 19.8616C20.1003 19.4961 20.214 19.0684 20.217 18.6403C20.2181 17.8669 20.2181 17.0931 20.217 16.3194C20.2148 15.9432 20.1371 15.5655 19.9659 15.2291C19.639 14.5555 18.9687 14.0685 18.2307 13.951C17.6016 13.8594 16.9766 13.7272 16.3766 13.5137C16.1583 13.4405 15.9411 13.3573 15.7125 13.3212C15.2469 13.2413 14.758 13.3076 14.3303 13.5082C13.8319 13.725 13.4918 14.1649 13.1038 14.5264C11.6546 13.6157 10.4218 12.37 9.49898 10.9297C9.80634 10.6087 10.159 10.3219 10.392 9.93801C10.7682 9.34721 10.8411 8.58303 10.6088 7.9245C10.4071 7.34916 10.2286 6.76277 10.1369 6.15872C10.0872 5.82485 10.0364 5.48326 9.88622 5.177C9.52916 4.38448 8.7002 3.84005 7.83222 3.8165C7.00952 3.81245 6.18644 3.8165 5.36374 3.81429C4.71294 3.80877 4.06582 4.0911 3.6263 4.5711C3.26814 4.95209 3.04912 5.45712 3.00826 5.97761C2.9836 6.21246 3.01967 6.44768 3.05133 6.67995C3.45845 10.037 4.97097 13.2329 7.24179 15.7304C8.86216 17.5113 10.8956 18.8987 13.1089 19.8359C14.3229 20.3302 15.5914 20.6928 16.8886 20.8872C17.2799 20.9317 17.6704 21.0315 18.0669 20.9902C18.8035 20.9302 19.497 20.4966 19.875 19.8616ZM18.6378 18.7776C18.5833 19.1379 18.245 19.4298 17.8806 19.4317C14.4532 19.1008 11.1797 17.5025 8.76388 15.0561C6.5354 12.775 5.03723 9.77457 4.62275 6.60743C4.59257 6.36522 4.51748 6.10645 4.62386 5.87197C4.7376 5.57602 5.04938 5.37282 5.36558 5.38387C6.16325 5.3824 6.96056 5.38497 7.75823 5.3824C8.0667 5.39123 8.37296 5.58596 8.47971 5.88117C8.5537 6.09062 8.56621 6.31516 8.60707 6.53197C8.69026 7.01308 8.81247 7.48646 8.96045 7.95137C9.02339 8.14204 9.09554 8.33014 9.14855 8.52376C9.22217 8.79211 9.12609 9.09211 8.92548 9.28168C8.60192 9.60782 8.27431 9.92991 7.95222 10.2575C7.72216 10.4872 7.66105 10.8616 7.80314 11.1531C8.66008 12.6608 9.80561 14.0066 11.1705 15.0778C11.4414 15.3034 11.7381 15.4949 12.0219 15.7036C12.266 15.8674 12.5226 16.0117 12.771 16.1688C12.9919 16.3153 13.2864 16.3474 13.5297 16.2406C13.6865 16.1762 13.8039 16.0499 13.9206 15.9322C14.2033 15.6506 14.4805 15.3638 14.7647 15.0837C14.9189 14.9398 15.1283 14.8474 15.3415 14.8606C15.5123 14.8614 15.6691 14.9364 15.8292 14.985C16.4701 15.2088 17.1319 15.376 17.8044 15.4706C17.9782 15.5007 18.1619 15.5284 18.3069 15.6366C18.5277 15.786 18.6536 16.0536 18.6444 16.3179C18.6397 17.1377 18.6529 17.9582 18.6378 18.7776Z" fill="white" />
    <path d="M17.8358 10.2397C17.8652 10.1205 17.8663 9.99569 17.8395 9.87605C17.6528 8.95911 17.1912 8.0985 16.5202 7.44512C15.858 6.78916 14.9933 6.34413 14.0767 6.17701C13.871 6.15198 13.6527 6.20535 13.4904 6.3364C13.2897 6.49247 13.1734 6.75051 13.1926 7.00413C13.2088 7.28647 13.3906 7.55371 13.6505 7.66635C13.8261 7.74291 14.0204 7.75616 14.1993 7.82279C15.2263 8.14819 16.0512 9.04415 16.2776 10.0991C16.3174 10.3023 16.3965 10.5084 16.5596 10.6446C16.7742 10.8331 17.0959 10.8927 17.3613 10.7842C17.5965 10.6951 17.7791 10.4842 17.8358 10.2397Z" fill="white" />
  </svg>
);

const IconOnline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="5" fill="#FF7D00" />
    <path d="M11.8481 3H12.1174C13.4741 3.02215 14.8287 3.33996 16.0402 3.95484C18.0205 4.94836 19.612 6.69633 20.4027 8.76773C20.7827 9.74859 20.9761 10.7973 21 11.8481V12.1181C20.9771 13.6045 20.5936 15.0871 19.8627 16.3836C19.1849 17.5955 18.223 18.647 17.0773 19.4317C15.6299 20.434 13.8787 20.9757 12.1206 21H11.8541C10.232 20.9705 8.61551 20.5078 7.24195 19.6405C6.20836 18.995 5.30766 18.1383 4.61121 17.1384C3.58184 15.6795 3.02461 13.9041 3 12.1209V11.8548C3.03023 10.0703 3.59238 8.29523 4.62738 6.83836C5.48414 5.61633 6.64781 4.6098 7.98375 3.94289C9.17871 3.34066 10.5118 3.02813 11.8481 3ZM10.2499 4.90582C9.53062 5.64586 9.08062 6.59684 8.73187 7.55625C9.17695 7.59598 9.62133 7.63957 10.0661 7.67789C10.5343 7.70074 11.003 7.71867 11.4716 7.73941C11.4716 6.53637 11.4716 5.33332 11.4716 4.13027C11.0019 4.2709 10.5899 4.55812 10.2499 4.90582ZM12.5273 4.12992C12.5273 5.33402 12.5273 6.53848 12.5273 7.74293C12.9946 7.725 13.4621 7.70988 13.9294 7.6902C14.3783 7.65504 14.8269 7.61637 15.2755 7.57875C15.0259 6.89039 14.7316 6.21152 14.3161 5.60578C13.8795 4.95926 13.2927 4.36055 12.5273 4.12992ZM5.82727 6.99902C6.1159 7.07145 6.40418 7.14668 6.69352 7.21699C7.01801 7.28379 7.34391 7.3432 7.6691 7.40613C7.90324 6.70195 8.19047 6.01113 8.58246 5.37867C8.73223 5.09918 8.93438 4.85309 9.11508 4.59363C7.83469 5.09285 6.69492 5.93449 5.82727 6.99902ZM14.8849 4.59363C15.0663 4.85414 15.2692 5.10129 15.4196 5.38219C15.8166 6.02344 16.1048 6.7248 16.3425 7.43848C16.6628 7.37941 16.9837 7.32387 17.304 7.26305C17.6071 7.19484 17.9087 7.11891 18.2111 7.04719C17.3395 5.95945 16.1843 5.10023 14.8849 4.59363ZM5.18777 7.90781C4.53984 8.9857 4.15699 10.2179 4.07367 11.4727C5.04715 11.4727 6.02098 11.473 6.9948 11.4723C7.03066 10.4482 7.15441 9.42727 7.38293 8.42812C6.64184 8.2977 5.90602 8.13281 5.18777 7.90781ZM16.6245 8.46117C16.8473 9.44977 16.9704 10.4588 17.0052 11.4713C17.979 11.472 18.9529 11.4716 19.9263 11.4713C19.8441 10.239 19.4735 9.02789 18.8456 7.96371C18.1172 8.17852 17.3733 8.33707 16.6245 8.46117ZM8.05055 11.4713C9.19102 11.4716 10.3311 11.4716 11.4716 11.4716C11.4716 10.5793 11.472 9.68742 11.4713 8.79551C10.4556 8.77195 9.44062 8.70621 8.43199 8.58246C8.20699 9.52957 8.08781 10.4992 8.05055 11.4713ZM12.5288 8.79867C12.528 9.68988 12.5284 10.5807 12.5284 11.4716C13.6689 11.4716 14.809 11.4716 15.9495 11.4713C15.915 10.5073 15.793 9.5468 15.575 8.60672C14.5636 8.72062 13.5465 8.7825 12.5288 8.79867ZM4.07367 12.5273C4.15559 13.7441 4.51629 14.9405 5.13047 15.9945C5.86664 15.7733 6.62004 15.6148 7.37766 15.4868C7.15723 14.5151 7.03559 13.523 6.99691 12.5277C6.02238 12.527 5.04785 12.5273 4.07367 12.5273ZM8.05266 12.5288C8.09238 13.4752 8.20945 14.4184 8.42812 15.3405C9.43887 15.2266 10.4549 15.1644 11.4716 15.1482C11.4741 14.275 11.472 13.4017 11.4727 12.5284C10.3325 12.5284 9.19277 12.528 8.05266 12.5288ZM12.5284 12.5284C12.5288 13.4027 12.528 14.2767 12.5288 15.1511C13.5444 15.1714 14.5587 15.2404 15.567 15.3616C15.787 14.4325 15.9087 13.4822 15.9473 12.5288C14.8076 12.5284 13.6682 12.5284 12.5284 12.5284ZM17.0031 12.5288C16.9669 13.5346 16.8361 14.5355 16.6181 15.5177C17.3694 15.6457 18.114 15.8148 18.8414 16.0426C19.4725 14.9774 19.8437 13.7634 19.9263 12.5288C18.9521 12.5284 17.9776 12.528 17.0031 12.5288ZM10.4876 16.2395C9.89906 16.2532 9.31441 16.3253 8.72766 16.3692C9.02648 17.1936 9.39563 18.0068 9.95004 18.6934C10.3448 19.1905 10.8543 19.6233 11.4716 19.8086C11.4716 18.6069 11.4716 17.4049 11.4713 16.2033C11.1432 16.2156 10.8156 16.2275 10.4876 16.2395ZM12.5288 16.2068C12.528 17.4074 12.5284 18.608 12.5284 19.8082C13.2716 19.5853 13.8454 19.0119 14.2774 18.39C14.7063 17.7772 15.0108 17.0885 15.266 16.3882C14.822 16.3478 14.3787 16.3056 13.9346 16.2673C13.466 16.2448 12.9974 16.2272 12.5288 16.2068ZM6.65906 16.6948C6.35742 16.7651 6.05684 16.8396 5.7559 16.912C6.64852 18.0388 7.84242 18.9251 9.18785 19.4341C8.48613 18.577 8.00449 17.5607 7.66453 16.512C7.32844 16.5686 6.99375 16.6318 6.65906 16.6948ZM16.3302 16.5373C15.986 17.5758 15.5093 18.5841 14.8121 19.4341C16.1404 18.9311 17.3223 18.0616 18.21 16.9539C17.9164 16.8793 17.6236 16.8034 17.3297 16.7306C16.9971 16.6628 16.6631 16.6027 16.3302 16.5373Z" fill="white" />
  </svg>
);

const IconByApp = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="5" fill="#D2464F" />
    <rect x="4.69751" y="4.69751" width="6.32028" height="6.32028" rx="0.683274" stroke="white" strokeWidth="1.02491" />
    <rect x="4.69751" y="12.9822" width="6.32028" height="6.32028" rx="0.683274" stroke="white" strokeWidth="1.02491" />
    <rect x="12.9827" y="4.69751" width="6.32028" height="6.32028" rx="0.683274" stroke="white" strokeWidth="1.02491" />
    <rect x="12.9827" y="12.9822" width="6.32028" height="6.32028" rx="0.683274" stroke="white" strokeWidth="1.02491" />
  </svg>
);